<template lang="pug">
	.flex-col.space-large.creative-break-insertion(v-if="editingTrack")
		.flex-col.space
			.font-small.upper.grey {{$tCaption('Break type')}}
			.flex-row.space.align-center
				fas(:icon="selectedBreak.icon")
				DxSelectBox.flex-1(:value.sync="editingTrack.breakType", :data-source="breakTypes", displayExpr="name", valueExpr="id")
		.flex-row.space
			EditableLabelField.flex-1(:caption="$tCaption('Start position')", :value.sync="editingTrack.start", stylingMode="filled", :editingMode="true", type="time", :editorOptions="{ seconds: true }")
			EditableLabelField.flex-1(:caption="$tCaption('Duration')", :value.sync="editingTrack.duration", stylingMode="filled", :editingMode="true", type="time", :secondsStep="5", :editorOptions="{ seconds: true }")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import Loader from 'app-core/Loader.vue';
	import EditableLabelField from 'app-core/EditableLabelField.vue';
	import DxSelectBox from 'devextreme-vue/select-box';
	
	export default {
		translationCategory: 'creative.Detail',
		name: 'creative-break-insertion',
		props: ['editingTrack', 'breakTypes'],
		components: {
			DxButton, Loader, EditableLabelField, DxSelectBox
		},

		data() {
			return {
				
			}
		},
		computed: {
			selectedBreak() {
				return this.breakTypes.find(f => f.id === this.editingTrack.breakType) || {};
			}
		},
		mounted() {
			if (__DEBUG__)
				window.breakInsertion = this;
		},
		methods: {
			
		}
	};
</script>
<style lang='scss'>

</style>
